export default __webpack_public_path__ + "static/media/KZ.T.13.2509 black.0bf1b22e.svg";